// extracted by mini-css-extract-plugin
export default {"tabList":"Tabs_tabList__uOj07","tabItem":"Tabs_tabItem__0bojK","tabItem_active":"Tabs_tabItem_active__QxIC3"};